import React from 'react';
import styled from '@emotion/styled';

function TopModuleTile(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    
//     const NavLink = styled.div`
//     background-image: url(${(props.tile.Icon) ? props.tile.Icon.path : ''});
//     color: ${props.module.TileFontColor};
//     background-color:${props.module.TileBackgroundColor};
  
//     &:hover{
//         background-image: url(${(props.tile.HoverIcon) ? props.tile.HoverIcon.path : ''});
//         color: ${props.module.TileFontColorHover};
//         background-color:${props.module.TileBackgroundColorHover};       
//     }
    
//   `
const NavLink = styled.div`
    // background-image: url(${(props.tile.Icon) ? props.tile.Icon.path : ''});
    background-color: ${props.module.TileBackgroundColor};
    color: ${props.module.TileFontColor};
        position: relative; 
        border-radius: 10px;
        padding: 1.2rem;
        min-height: 75px;
        cursor: pointer;

    /* ✅ Apply normal font color to ALL text inside the tile */
    
    & *:not(img) {
        color: ${props.module.TileFontColor} !important;
    }
    &:hover {
        // background-image: url(${(props.tile.HoverIcon) ? props.tile.HoverIcon.path : ''});
        background-color: ${props.module.TileBackgroundColorHover};

        /* ✅ Apply HOVER font color to ALL text inside the tile */
        
    & *:not(img) {
                color: ${props.module.TileFontColorHover} !important;
            }

        }
    
    .tile-icon {
            position: absolute;
            right: 5%;
            top: 50%;
            transform: translateY(-50%);
            width: 12%;
            height: auto;
        }
        
        .default-icon { opacity: 1; }
        .hover-icon { opacity: 0; }
        &:hover .default-icon { opacity: 0; }
        &:hover .hover-icon { opacity: 1; }
`;

    return (
       
        <div className=''>
            <a aria-label={props.tile.ariaLabel || undefined } href={props.tile.link}>
            {/* <NavLink className={"d-flex align-items-center p-3  top-module-tile "} dangerouslySetInnerHTML={renderContent(props.tile.Title)}>
            </NavLink>   */}
            <NavLink className="d-flex align-items-center top-module-tile">
                    
                    {/* ✅ Inject text content */}
                    <div dangerouslySetInnerHTML={renderContent(props.tile.Title)} />

                    {/* ✅ Normal Icon */}
                    {props.tile.Icon.path && (
                        <img
                            className="tile-icon default-icon"
                            src={props.tile.Icon.path}
                            alt={props.tile.altText}
                        />
                    )}

            {/* ✅ Hover Icon (shown only on hover using CSS) */}
                    {props.tile.HoverIcon.path && (
                        <img
                            className="tile-icon hover-icon"
                            src={props.tile.HoverIcon.path}
                            alt={props.tile.altText}
                        />
                    )}
                </NavLink>
            </a>     
        </div>

    )
}
export default TopModuleTile;